"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _utils = require("../../utils");
var _linkFieldSrc = require("../../lib/linkFieldSrc");
var _lodash = require("lodash");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 *  A react component to create a horizontal card
 *
 * @param {object} props The properties passed into the object
 * @param {object} props.rendering Fields to render
 * @param {object} props.rendering.fields Fields
 *
 * @returns {React.ReactElement} A horizontal card
 */
function VideoPlayer(props) {
  if (!props.rendering.fields || !props.rendering.fields.VideoLink.value || (0, _lodash.isEmpty)(props.rendering.fields.VideoLink.value.href)) return null;
  var extractedFields = (0, _utils.extractFieldsFn)(props);
  var {
    linkUrl
  } = (0, _linkFieldSrc.linkFieldSrc)(extractedFields.VideoLink.value);
  if (extractedFields.videoParams.length > 0) {
    var urlWithParam = linkUrl.split('?');
    var queryStringData = urlWithParam.length === 1 ? '' : urlWithParam[1];
    extractedFields.videoParams.map(param => {
      if (!(0, _lodash.isEmpty)(param.fields.Key.value)) {
        if ((0, _lodash.isEmpty)(queryStringData)) queryStringData = queryStringData.concat(param.fields.Key.value, '=', param.fields.Value.value);else queryStringData = queryStringData.concat('&', param.fields.Key.value, '=', param.fields.Value.value);
      }
    });
    if (!(0, _lodash.isEmpty)(queryStringData)) linkUrl = "".concat(urlWithParam[0], "?").concat(queryStringData);
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    id: (0, _utils.getComponentContentId)(props.rendering.dataSource),
    className: "app-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "embed-responsive video-wrapper"
  }, /*#__PURE__*/_react.default.createElement("iframe", {
    src: linkUrl,
    frameBorder: "0",
    allowFullScreen: "",
    title: extractedFields.Title.value
  })));
}
var _default = exports.default = VideoPlayer;